'use strict'

const React = require('react')
const SuperAgent = require('superagent')
const MarkDownHelper = require('./MarkDownHelper')
const propTypes = require('prop-types');
const { settings: { docsAPIEndpointJSON, docsAPIEndpoint } } = require('../../../../../config/index')
const { string, array } = propTypes
const createReactClass = require('create-react-class');

const DocWarrior = createReactClass({
  mixins: [MarkDownHelper],

  propTypes: {
    id: string,
    functionParams: array
  },

  getDefaultProps () {
    return {
      functionParams: []
    }
  },

  getInitialState () {
    return {
      content: 'Loading content...'
    }
  },

  shouldComponentUpdate (nextProps, nextState) {
    if (this.checkUpdated(nextState.content, this.state.content)) return true
  },

  checkUpdated (next, current) {
    if (typeof next === 'object') {
      return JSON.stringify(next) !== JSON.stringify(current)
    }
    return next !== current
  },

  makeRequestURL () {
    const { functionParams } = this.props
    const endpoint = functionParams[1] && functionParams[1] === 'json' ? docsAPIEndpointJSON : docsAPIEndpoint
    return endpoint + '&docs=' + functionParams[0] + '&noCache=1'
  },

  html (body) {
    if (!body.html) return false
    this.setState({
      content: body.html
    })
  },

  parseDocs (err, res) {
    const { functionParams } = this.props
    if (err || !res || !res.body) return false
    const specialMode = functionParams[2] ? functionParams[2] : false
    if (functionParams[1] && functionParams[1] === 'json') return this.parseMarkDown(res.body, specialMode)
    return this.html(res.body)
  },

  componentWillMount () {
    if (!/-new/.test(this.props.id)) return
    SuperAgent
      .get(this.makeRequestURL())
      .end(this.parseDocs)
  },

  parseMarkDown (body, specialMode) {
    if (!body.length) return
    let html = '<div class="mark-down">'
    body.map((section) => {
      section.map((item) => {
        html += this.renderItem(item, specialMode)
      })
    })
    html += specialMode && specialMode === 'accordion' ? '</div></div></div>' : '</div>'
    this.setState({
      content: html
    })
  },

  render () {
    const { id } = this.props
    const { content } = this.state
    return (
      <div id={id} dangerouslySetInnerHTML={{ __html: content }} />
    )
  }

})

module.exports = DocWarrior





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/markdown/DocWarrior.jsx